export const globalErrors = {
  invalidPushWithSchema: {
    errorMessage:
      "Using pushWithSchema without teamSchema query param available in the URL, make sure you are using this method where teamSchema is available in the url path.",
  },
};
